import { render } from "./VendingMachineByType.vue?vue&type=template&id=28a39ea0"
import script from "./VendingMachineByType.vue?vue&type=script&lang=js"
export * from "./VendingMachineByType.vue?vue&type=script&lang=js"
script.render = render

export default script